import type { ReactNode } from "react";

type HintCalloutProps = {
  title: string;
  children: ReactNode;
};

function LightbulbIcon() {
  return (
    <svg
      className="hint-callout__icon"
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26A7 7 0 0 0 12 2Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HintCallout({ title, children }: HintCalloutProps) {
  return (
    <div
      className="hint-callout"
      role="note"
      aria-label={title}
    >
      <LightbulbIcon />
      <div className="hint-callout__content">
        <div className="hint-callout__title">{title}</div>
        <p className="hint-callout__body">{children}</p>
      </div>
    </div>
  );
}
